<script setup lang="ts">
import { onServerPrefetch, useSSRContext, watch, onBeforeMount, computed } from 'vue';
import { useRoute } from 'vue-router'
import { useAppStore } from '@/stores/app';

export interface ItemType {
  path: string;
  label: string;
}

const props = defineProps({
  itemList: {
    type: Array<ItemType>,
    default: () => [],
  },
  defaultTitle: {
    type: String,
    default: '',
  },
});

const appStore = useAppStore();
const route = useRoute()

// 在路由变化时更新 selectedIndex
const selectedIndex = computed(() => props.itemList.findIndex((item) => item.path === route.path));

const getTitle = () => props.defaultTitle ? `${props.itemList[selectedIndex.value].label} - ${props.defaultTitle}` : props.itemList[selectedIndex.value].label;

onBeforeMount(() => {
  appStore.setTitle(getTitle());
});

onServerPrefetch(async () => {
  const ctx = useSSRContext() as Record<string, any>;
  ctx.title = getTitle()
});

watch(() => route.path, () => {
  appStore.setTitle(getTitle());
});
</script>

<template>
  <div class="container mx-auto <sm:px-16 <xl:px-24">
    <div class="relative mb-48 mt-45 w-full flex items-center justify-between <md:mb-32 <md:mt-32">
      <div class="relative w-full flex items-center justify-between <md:overflow-x-auto">
        <div
          v-for="(item, index) in props.itemList"
          :key="item.path"
          class="w-20% px-10 <md:w-auto <md:flex-shrink-0"
        >
          <RouterLink
            class="mb-16 block items-center break-words text-center text-balance text-24 leading-36 no-underline <md:mb-12 <md:whitespace-nowrap <md:text-16 <md:leading-28 focus-visible:outline-unset"
            :class="[selectedIndex === index ? 'text-[#1180FF]' : 'text-[#2D2D2D]']"
            :to="item.path"
          >
            {{ item.label }}
          </RouterLink>
        </div>

        <div
          class="absolute bottom-0 left-0 h-2 w-20% bg-[#1180ff] transition-transform duration-300 <md:hidden"
          :style="{ transform: `translateX(${selectedIndex * 100}%)` }"
        >
        </div>
      </div>
    </div>

    <RouterView />
  </div>
</template>
